import {
  DigitalFormat,
  hiConsistsOfCustomerOrderBiId,
} from '@global/types/types';
import {
  CART_CHECKOUT_BASE_URL,
  CART_PATH,
  REGISTER_PATH,
} from '@global/App/constants/constants';
import { SiteConfig } from './SiteConfig';

const TEXTBOOK_RENTAL_IDS = ['rental', 'Alta Rental'];

export const checkIsGuestAllowed = (
  products: hiConsistsOfCustomerOrderBiId[]
): boolean => {
  const hasRestrictedProducts = products.some(({ biiSalable }) => {
    const isDigital = biiSalable.wEditionFormat === DigitalFormat.DIGITAL;
    const isPhysical = biiSalable.wEditionFormat === DigitalFormat.PHYSICAL;
    const isPhygital =
      biiSalable.wEditionFormat === DigitalFormat.DIGITAL_AND_PHYSICAL;
    const rentalCategory = biiSalable.maCategories.some((c) =>
      TEXTBOOK_RENTAL_IDS.includes(c.catId)
    );

    return isDigital || isPhygital || (isPhysical && rentalCategory);
  });

  return !hasRestrictedProducts;
};

export const redirectGuestToAuth = () => {
  const { siteId, locale } = SiteConfig.getConfig();
  const errorFlagKey = `${siteId}.${locale}.show.registration.guest.error.message`;

  const cartRedirectUrl = SiteConfig.buildRedirectUrl(
    CART_CHECKOUT_BASE_URL,
    CART_PATH
  );
  const authRedirectUrl = SiteConfig.buildRedirectUrl(
    CART_CHECKOUT_BASE_URL,
    REGISTER_PATH,
    { target: cartRedirectUrl }
  );

  localStorage.setItem(errorFlagKey, 'true');
  window.location.href = authRedirectUrl;
};
